<template>
  <div id="menuRoleSelector">
    <span v-if="isAdmin">
      <v-menu v-model="showMenu" absolute offset-y style="max-width: 600px"
        ><template v-slot:activator="{ on, attrs }">
          <span v-on="on" style="cursor: pointer">{{ roleLabel }}</span>
        </template>
        <v-list dense>
          <v-list-item v-for="(item, index) in items" :key="index">
            <v-list-item-title style="cursor: pointer" @click="setRole(item)">{{
              item.rolename
            }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </span>
  </div>
</template>

<script>
import Trimaster from "@/plugins/servers/trimaster.js";
import moment from "moment";
import vuetifyToast from "@/vuetifyToast.js";
import { mapGetters, mapActions } from "vuex";
import messageBox from "@/MessageBox.js";

export default {
  name: "",
  props: [],
  components: {},
  beforeMount() {
    let me = this;
    let isAdmin = false;
    for (let i = 0; i < this.getUser.roles.length; i++) {
      if (this.getUser.roles[i].id == 7) {
        isAdmin = true;
        break;
      }
    }
    this.isAdmin = isAdmin;
    if (this.isAdmin) {
      Trimaster.get("ag_roles", this.getUser.apitoken, {
        filter: {
          order: "rolename",
        },
      }).then(function ([res, err]) {
        me.items = res;
      });
    }
  },
  mounted() {},
  data() {
    return {
      isAdmin: false,
      showMenu: false,
      items: [],
      roleLabel: "ADMIN",
    };
  },

  computed: {
    ...mapGetters(["getUser"]),
  },
  watch: {},
  methods: {
    setRole(menuItem) {
      this.roleLabel = menuItem.rolename;
      this.$emit("change", menuItem.id);
      this.$store.dispatch('setSelectedRoleId', menuItem.id);
    },
  },
};
</script>
<style lang="scss">
</style>

